import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-dotdotdot',
  templateUrl: './dotdotdot.component.html',
  styleUrls: ['./dotdotdot.component.scss'],
})
export class DotdotdotComponent {
  @Input({ required: true }) public innerText: string;
  @Input({ required: true }) public numberLines: number;
  public statusFlag = true;

  public changeStatusFlag(): void {
    this.statusFlag = !this.statusFlag;
  }
}
